export default "__VITE_ASSET__BzeK8NCm__"